export default __webpack_public_path__ + "static/media/gb-sct.74444e72.svg";